// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__T3xsJ","signatureButtonsRight":"ModalSign_signatureButtonsRight__26hn0"};